module.exports = __webpack_public_path__ + "img/dojo.1d42b3a1.jpg";